import React from 'react';
import { translate } from '../../i18n';
import Typography from '../Typography';

interface PasswordQualityProps {
  valid: boolean;
}

const PasswordQuality: React.FC<PasswordQualityProps> = ({ valid }) => {
  return (
    <Typography classNames="ckp-m-password-quality">
      {translate('password.quality.label')}:{' '}
      {valid ? (
        <Typography variant="span" classNames="u-text-success">
          {translate('password.quality.valid')}
        </Typography>
      ) : (
        <Typography variant="span" classNames="u-text-danger">
          {translate('password.quality.invalid')}
        </Typography>
      )}
    </Typography>
  );
};

export default PasswordQuality;
